import React from 'react';
import LocalizationContext from './LocalizationContext';
import translations from '../localization';

/**
 * Provider component for localization
 * This wrapper provides all translations to the app via Context
 */
const LocalizationProvider = ({ children }) => {
  // For now, we're simply providing the English translations
  // In the future, this could be expanded to handle language switching
  return (
    <LocalizationContext.Provider value={translations}>
      {children}
    </LocalizationContext.Provider>
  );
};

export default LocalizationProvider;